import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { MingaPermission } from 'libs/domain';

import { PermissionsService } from '@app/src/app/permissions';

import { CheckinManagerRoutes } from '../checkin-manager.constants';

@Injectable()
export class ViewReportsGuard {
  constructor(private _router: Router, private _permissions: PermissionsService) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const canActivate = this._permissions.hasPermission(MingaPermission.CHECKIN_VIEW_REPORTS);

    if (!canActivate) this._router.navigate([CheckinManagerRoutes.ROOT, CheckinManagerRoutes.REPORTS]);

    return canActivate;
  }
}
